/* eslint-disable react/forbid-prop-types */
import React, { useMemo } from 'react';
import { extend } from '@thd-nucleus/data-sources';
import {
  PodRow,
  PodSection,
  ProductPod,
  ProductImage,
  ProductBadge,
  ProductSponsored,
  ProductRating,
  ProductIdentifier,
  ProductATC,
  PodTapper
} from '@thd-olt-component-react/product-pod';
import {
  bool as boolType,
  string as stringType,
  number as numType,
  object,
  any,
  func,
  array
} from 'prop-types';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { Price } from '@thd-olt-component-react/price';
import { AddToList } from '@thd-olt-component-react/add-to-list';
import { useTheme } from '@thd-olt-component-react/theme-provider';
import './FbrProductPod.scss';

const FbrProductPod = (props) => {

  const {
    product,
    itemId,
    storeId,
    position,
    parent,
    hideRating,
    scheme,
    anchorProduct,
    onclick,
    fbrItem,
    recommendedFeatureSet,
    recommendedProductSet,
    current,
    url,
    isMobile,
    brandTitleMaxLine
  } = props;

  const merchRec = useMemo(() => {
    return `MERCH=REC-_-${scheme}-_-${anchorProduct}-_-${position}-_-n/a-_-n/a-_-n/a-_-n/a-_-n/a`;
  }, [anchorProduct, position]);

  const { preferredPriceFlag } = product?.pricing || {};

  const theme = useTheme(FbrProductPod);
  const { hideAddToList } = theme.props;

  const handleClick = () => {
    const productPodEventData = {
      podAction: 'product pod',
      podAnchorSku: itemId,
      target: '_self',
      parent
    };
    window.LIFE_CYCLE_EVENT_BUS.trigger('product-pod-v7.click', productPodEventData);
  };

  return (
    <ProductPod
      itemId={itemId}
      storeId={storeId}
      padding="sui-p-0"
      analyticsData={{ parent, position, scheme, anchorProduct }}
      render={(pod) => (
        <div className={(props?.current ? 'current-product-pod' : ' fbr-product-pod ')}>
          <a
            className="sui-top-0 sui-left-0 sui-absolute sui-size-full sui-z-1"
            href={url}
            aria-label="Link"
            onClick={handleClick}
          />
          <PodSection columnAlign>
            {!hideAddToList && (
              <PodRow noPadding rowReverse>
                <PodTapper fitWidth zIndex>
                  <AddToList
                    itemId={pod.itemId}
                    storeId={storeId}
                    showIconButton
                  />
                </PodTapper>
              </PodRow>
            )}
            <PodTapper zIndex>
              <ProductImage
                itemId={pod.itemId}
                showSecondaryImage={pod.showSecondaryImage}
                merchQueryParam={merchRec}
                onClick={(event) => {
                  if (onclick) {
                    onclick(event, fbrItem);
                  }
                }}
              />
            </PodTapper>
            <PodSection noPadding columnAlign>
              <PodTapper fitWidth zIndex>
                <div className="product-header">
                  <ProductHeader
                    brand="inline"
                    brandFontSize="sm"
                    itemId={pod.itemId}
                    brandTitleMaxLine={isMobile ? 3 : brandTitleMaxLine}
                    disableShopThisCollection
                    merchQueryParam={merchRec}
                    onClick={(event) => {
                      if (current) {
                        event.preventDefault();
                      }
                    }}
                  />
                </div>
              </PodTapper>
              {!hideRating && (
                <PodTapper fitWidth zIndex>
                  <ProductRating itemId={pod.itemId} hideRating={hideRating} merchQueryParam={merchRec} />
                </PodTapper>
              )}
              <PodTapper zIndex pointerNone aPointer buttonPointer spanPointer>

                <Price
                  itemId={pod.itemId}
                  large={false}
                  storeId={storeId}
                  displayEachUom={false}
                  hideSavingsText={!preferredPriceFlag}
                  showPreferredPricingBadge
                  stackWasPrice
                />
              </PodTapper>
            </PodSection>
          </PodSection>
        </div>
      )}
    />
  );
};

FbrProductPod.dataModel = extend(
  ProductPod,
  ProductImage,
  ProductBadge,
  ProductSponsored,
  ProductRating,
  ProductIdentifier,
  ProductATC,
  Price,
  ProductHeader,
  AddToList,
);

FbrProductPod.propTypes = {
  storeId: stringType,
  product: any,
  fbrItem: any,
  current: boolType,
  position: numType,
  parent: stringType,
  hideRating: boolType,
  anchorProduct: stringType,
  itemId: stringType,
  scheme: stringType,
  onclick: func,
  recommendedFeatureSet: stringType,
  recommendedProductSet: stringType,
  url: stringType.isRequired,
  brandTitleMaxLine: numType,
  isMobile: boolType,
};
FbrProductPod.defaultProps = {
  storeId: '',
  position: '',
  current: false,
  parent: '',
  hideRating: false,
  anchorProduct: '',
  itemId: '',
  scheme: '',
  onclick: () => { },
  product: null,
  fbrItem: [],
  recommendedFeatureSet: '',
  recommendedProductSet: '',
  brandTitleMaxLine: 2,
  isMobile: false
};

FbrProductPod.displayName = 'FbrProductPod';

FbrProductPod.themeProps = {
  hideAddToList: boolType
};

FbrProductPod.defaultThemeProps = {
  hideAddToList: false
};

export {
  FbrProductPod
};
